(function () {

  function initSwiper(slider) {
    if (slider.classList.contains('swiper-initialized')) return;

    const inner = slider.querySelector('.product-page .vtl-rv-main-widget .vtl-product-carousel__slider-inner');
    if (!inner) return;

    const cards = inner.querySelectorAll('.product-page .vtl-rv-main-widget .vtl-product-card');
    if (cards.length === 0) return;

    // Add base classes
    slider.classList.add('swiper');
    inner.classList.add('swiper-wrapper');

    // Wrap cards (only if not already wrapped)
    cards.forEach(card => {
      if (!card.parentElement.classList.contains('swiper-slide')) {
        const wrapper = document.createElement('div');
        wrapper.className = 'swiper-slide';

        card.parentNode.insertBefore(wrapper, card);
        wrapper.appendChild(card);
      }
    });

    // Avoid duplicate navigation
    if (!slider.querySelector('.swiper-button-next')) {
      const nextBtn = document.createElement('div');
      nextBtn.classList.add('swiper-button-next','swiper-arr');
      nextBtn.innerHTML = '<span>→</span>';

      const prevBtn = document.createElement('div');
      prevBtn.classList.add('swiper-button-prev','swiper-arr');
      prevBtn.innerHTML = '<span>→</span>';

      slider.insertAdjacentElement('afterend', nextBtn);
      slider.insertAdjacentElement('afterend', prevBtn);

      // Ensure Swiper is loaded
      if (typeof Swiper === 'undefined') return;

      new Swiper(slider, {
        loop: false,
        spaceBetween: 24,
        slidesPerView: 1,

        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
        },

        breakpoints: {
          0: {
            slidesPerView: 1.3,
          },
          601: {
            slidesPerView: 2.4,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 24,
          }
        }
      });
    }
  }

  function scanAndInit() {
    document.querySelectorAll('.product-page .vtl-rv-main-widget .vtl-product-carousel__slider').forEach(initSwiper);
  }

  // Initial run
  scanAndInit();

  // Watch dynamic DOM (Vitals)
  const observer = new MutationObserver(() => {
    scanAndInit();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();


document.addEventListener("DOMContentLoaded", function () {

  // target ALL faq sections (regardless of type)
  document.querySelectorAll(".product-faq").forEach((section) => {

    const items = section.querySelectorAll(".faq-item");

    items.forEach((item) => {
      const question = item.querySelector(".faq-question");
      const answer = item.querySelector(".faq-answer");

      // set default active
      if (item.classList.contains("active")) {
        answer.style.maxHeight = answer.scrollHeight + "px";
      }

      question.addEventListener("click", () => {

        const isActive = item.classList.contains("active");

        // close only inside THIS section
        items.forEach((i) => {
          i.classList.remove("active");
          i.querySelector(".faq-answer").style.maxHeight = null;
        });

        // open current
        if (!isActive) {
          item.classList.add("active");
          answer.style.maxHeight = answer.scrollHeight + "px";
        }

      });
    });

  });

  const target = document.querySelector('.tt-one');
  const elementsToToggle = document.querySelectorAll('.tt-one, .bt-one');

  window.addEventListener('scroll', () => {
    if (!target) return;

    const rect = target.getBoundingClientRect();

    if (rect.top + rect.height / 2 <= 0) {
      elementsToToggle.forEach(el => el.classList.add('scrolled'));
    } else {
      elementsToToggle.forEach(el => el.classList.remove('scrolled'));
    }
  });

}); 